import { type MustGateEntry, mustGateEntryMatch, mustGateEntryTool } from '@zerohuman/shared'

/** A gate row as the task forms hold it: enough to say whether it already covers a required gate. */
type FormGate = { tool: string; owner: string; approval: string; match?: Record<string, unknown> }

/**
 * The CEO gate row the tools picker says a task needs for `entry` (`require-gates`), or null when `gates` already hold
 * one covering it: a row on the tool with no `match`, or with the entry's own `match`. An entry narrowed to some calls
 * (`{ tool, match }`) is given a row narrowed the same way, so the tool's other calls still run and the narrowing is
 * kept on save.
 */
export function requiredGateRow(gates: readonly FormGate[], entry: MustGateEntry): FormGate | null {
    const tool = mustGateEntryTool(entry)
    const match = mustGateEntryMatch(entry)
    const covered = gates.some(
        gate =>
            gate.tool === tool &&
            (!gate.match || (match !== null && JSON.stringify(gate.match) === JSON.stringify(match))),
    )
    if (covered) {
        return null
    }
    return { tool, owner: 'ceo', approval: 'manual', ...(match ? { match } : {}) }
}
